export default __webpack_public_path__ + "static/media/StatusErrorIcon.53f203d3.svg";